import axios from 'axios';

// 接口请求路径
const api_url = 'https://api.yunxiucap.com/admin'; // 正式
// var api_url = 'http://yunxiucap.api.jeachou.com/admin'; // 测试

const uploadFile = file => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('token', sessionStorage.getItem('token') || '');

  return axios.post(api_url + '/upload/oss_save', formData).then(response => {
    const result = response && response.data && response.data.code !== undefined
      ? response.data
      : response;
    if (!result || !result.data) {
      return Promise.reject({ msg: 'OSS上传失败：服务器未返回文件地址' });
    }
    return result.data;
  }).catch(error => {
    const response = error && error.response ? error.response.data : error;
    return Promise.reject(response || { msg: 'OSS上传失败：网络异常，请稍后重试' });
  });
}

const uploadErrorMessage = error => {
  return error && error.msg ? error.msg : 'OSS上传失败：网络异常，请稍后重试';
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

const formatTime = (date, e) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  if (e == 1) {
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  } else if (e == 2) {
    return [year, month, day].map(formatNumber).join('.');
  } else if (e == 3) {
    return [year, month, day].map(formatNumber).join('-');
  } else if (e == 4) {
    return year + '' + month + '' + day
  }
}

var toTop = function () {
  document.getElementsByClassName('ant-layout')[1].scrollTop = 0;
}

export default {
  api_url,
  uploadFile,
  uploadErrorMessage,
  formatTime,
  toTop
}



// WEBPACK FOOTER //
// ./src/util/common.js